export default __webpack_public_path__ + "81b2c2cf2c8c827d26467de1e32a8a74.png";